import { useMediaFetchService } from 'modules/campaigns/modules/creative-editor/components/MediaTabs/services';
import { fetchFavoritedMedia } from 'modules/campaigns/modules/creative-editor/flows';

export const useFavoritedMediaFetchService = ({ accountId, loadParams }) =>
    useMediaFetchService({ accountId, fetch: fetchFavoritedMedia, loadParams });
